import React from 'react';

import CheckBox from './checkBox';
import EmailInput from './emailInput';
import HiddenInput from './hiddenInput';
import LinkedInputs from './linkedInputs';
import RadioButton from './radioButton';
import Select from './select';
import TelInput from './telInput';
import TextInput from './textInput';
import TextArea from './textArea';
import DateSelect from './dateSelect';
import TimeSelect from './timeSelect';
import Label from './label';
import Upload from './Upload';
import LiquidAssets from './depotCheck/liquidAssets';
import PropertyHoldings from './depotCheck/propertyHoldings';
import ReadinessToAssumeRisk from './depotCheck/readinessToAssumeRisk';
import SelectDataSource from './depotCheck/selectDataSource';

/* eslint-disable complexity, func-names */
const FieldRenderer = (function () {
  function chooseFor(
    fields,
    formId,
    requiredList = [],
    placeholderAsLabels = false,
    contentArticleFormId,
    consultant,
    className = 'formgroup'
  ) {
    return fields.map(
      (field, index) =>
        ({
          raw_html: (
            <div
              dangerouslySetInnerHTML={{ __html: field.raw_html }}
              className={field.options && field.options.class_name}
              key={`raw-${index}`}
            />
          ),
          text: (
            <TextInput
              internalTitle={field.internal_title}
              label={placeholderAsLabels ? '' : field.label}
              placeholder={placeholderAsLabels ? field.label : ''}
              className={className}
              formId={formId}
              contentArticleFormId={contentArticleFormId}
              required={requiredList.indexOf(field.internal_title) > -1}
              options={field.options}
              key={`text-${index}`}
            />
          ),
          tel: (
            <TelInput
              internalTitle={field.internal_title}
              label={placeholderAsLabels ? '' : field.label}
              placeholder={placeholderAsLabels ? field.label : ''}
              className={className}
              formId={formId}
              contentArticleFormId={contentArticleFormId}
              required={requiredList.indexOf(field.internal_title) > -1}
              options={field.options}
              key={`tel-${index}`}
            />
          ),
          email: (
            <EmailInput
              internalTitle={field.internal_title}
              label={placeholderAsLabels ? '' : field.label}
              placeholder={placeholderAsLabels ? field.label : ''}
              className={className}
              formId={formId}
              contentArticleFormId={contentArticleFormId}
              required={requiredList.indexOf(field.internal_title) > -1}
              options={field.options}
              key={`email-${index}`}
            />
          ),
          select: (
            <Select
              internalTitle={field.internal_title}
              label={placeholderAsLabels ? '' : field.label}
              placeholder={placeholderAsLabels ? field.label : ''}
              className={className}
              formId={formId}
              contentArticleFormId={contentArticleFormId}
              required={requiredList.indexOf(field.internal_title) > -1}
              options={field.options}
              key={`select-${index}`}
            />
          ),
          check_box: (
            <CheckBox
              internalTitle={field.internal_title}
              label={field.label}
              className={className}
              formId={formId}
              contentArticleFormId={contentArticleFormId}
              required={requiredList.indexOf(field.internal_title) > -1}
              options={field.options}
              key={`checkbox-${index}`}
            />
          ),
          radio_button: (
            <RadioButton
              internalTitle={field.internal_title}
              label={placeholderAsLabels ? '' : field.label}
              className={className}
              formId={formId}
              contentArticleFormId={contentArticleFormId}
              required={requiredList.indexOf(field.internal_title) > -1}
              options={field.options}
              key={`radiobutton-${index}`}
            />
          ),
          hidden: (
            <HiddenInput
              internalTitle={field.internal_title}
              formId={formId}
              contentArticleFormId={contentArticleFormId}
              options={field.options}
              key={`hidden-${index}`}
            />
          ),
          textarea: (
            <TextArea
              internalTitle={field.internal_title}
              label={placeholderAsLabels ? '' : field.label}
              placeholder={placeholderAsLabels ? field.label : ''}
              className={className}
              formId={formId}
              contentArticleFormId={contentArticleFormId}
              required={requiredList.indexOf(field.internal_title) > -1}
              options={field.options}
              key={`textarea-${index}`}
            />
          ),
          linked: (
            <LinkedInputs
              fields={field.fields}
              formId={formId}
              contentArticleFormId={contentArticleFormId}
              requiredList={requiredList}
              placeholderAsLabels={placeholderAsLabels}
              consultant={consultant}
              key={`linked-${index}`}
            />
          ),
          date_select: (
            <DateSelect
              internalTitle={field.internal_title}
              label={placeholderAsLabels ? '' : field.label}
              placeholder={placeholderAsLabels ? field.label : ''}
              formId={formId}
              contentArticleFormId={contentArticleFormId}
              className={className}
              required={requiredList.indexOf(field.internal_title) > -1}
              key={`date-${index}`}
            />
          ),
          time_select: (
            <TimeSelect
              internalTitle={field.internal_title}
              label={placeholderAsLabels ? '' : field.label}
              placeholder={placeholderAsLabels ? field.label : ''}
              formId={formId}
              contentArticleFormId={contentArticleFormId}
              className={className}
              required={requiredList.indexOf(field.internal_title) > -1}
              key={`time-${index}`}
            />
          ),
          label: (
            <Label
              internalTitle={field.internal_title}
              options={field.options}
              formId={formId}
              contentArticleFormId={contentArticleFormId}
              className={className}
              key={`label-${index}`}
            />
          ),
          upload: (
            <Upload
              internalTitle={field.internal_title}
              options={field.options}
              formId={formId}
              contentArticleFormId={contentArticleFormId}
              className={className}
              key={`upload-${index}`}
            />
          ),
          liquid_assets: (
            <LiquidAssets
              label={placeholderAsLabels ? '' : field.label}
              internalTitle={field.internal_title}
              formId={formId}
              required={requiredList.indexOf(field.internal_title) > -1}
              placeholder={placeholderAsLabels ? field.label : ''}
              contentArticleFormId={contentArticleFormId}
              key={`liquidassets-${index}`}
            />
          ),
          property_holdings: (
            <PropertyHoldings
              label={placeholderAsLabels ? '' : field.label}
              internalTitle={field.internal_title}
              formId={formId}
              required={requiredList.indexOf(field.internal_title) > -1}
              placeholder={placeholderAsLabels ? field.label : ''}
              contentArticleFormId={contentArticleFormId}
              key={`propertyholdings-${index}`}
            />
          ),
          readiness_to_assume_risk: (
            <ReadinessToAssumeRisk
              internalTitle={field.internal_title}
              formId={formId}
              required={requiredList.indexOf(field.internal_title) > -1}
              placeholder={placeholderAsLabels ? field.label : ''}
              contentArticleFormId={contentArticleFormId}
              key={`readinesstoassumerisk-${index}`}
            />
          ),
          select_data_source: (
            <SelectDataSource
              internalTitle={field.internal_title}
              label={placeholderAsLabels ? '' : field.label}
              placeholder={placeholderAsLabels ? field.label : ''}
              className={className}
              formId={formId}
              contentArticleFormId={contentArticleFormId}
              required={requiredList.indexOf(field.internal_title) > -1}
              options={field.options}
              consultant={consultant}
              key={`selectdatasource-${index}`}
            />
          )
        }[field.field_type])
    );
  }

  return {
    chooseFor
  };
})();
/* eslint-enable complexity, func-names */

export default FieldRenderer;



// WEBPACK FOOTER //
// ./components/forms/fieldRenderer.js